import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleRight } from '@fortawesome/free-solid-svg-icons';
import EngineCommon from './EngineCommon';
import { useHistory } from "react-router-dom";

const EngineResult = ({
  brandName,
  modelNumber,
  engineId,
  startYear,
  stopYear,
  horsepower,
  stroke,
  cylinders,
  marketId,
  source = "model" // default
}) => {
  const history = useHistory();
  const targetUrl = source === "simple"
    ? `/searchEngine/${engineId}`
    : `/engine/${engineId}`;

  const handleClick = () => {
    history.push(targetUrl);
  };

  return (
    <div className="result-item" onClick={handleClick} style={{ cursor: 'pointer' }}>
      <div className="row">
        <EngineCommon
          brandName={brandName}
          modelNumber={modelNumber}
          startYear={startYear}
          stopYear={stopYear}
          horsepower={horsepower}
          stroke={stroke}
          cylinders={cylinders}
        />
        <div className="result-link">
          <FontAwesomeIcon icon={faAngleRight} className="go-to-category" />
        </div>
      </div>
    </div>
  );
};

export default EngineResult;
